import {Component, OnInit, ViewContainerRef, Renderer2, Inject} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {LoginService} from 'projects/core/src/public-api';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {UsersService} from '../../../data/users.service';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {ConfirmationService} from 'primeng/api';
import moment from 'moment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UserRole} from 'projects/core/src/lib/login/data/user-role';
import {AppStateStore} from 'projects/desktop/src/app/data/app-state.store';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-edit-dialog',
  templateUrl: './user-edit-dialog.component.html',
  styleUrls: ['./user-edit-dialog.component.scss'],
  providers: [ConfirmationService]
})
export class UserEditDialogComponent implements OnInit {
  user: User;
  tempUser: User;

  currentUser: User;

  tempWorkTime: Date;

  buttonLabel: string;

  newPassword: string;

  confirmedPassword: string;

  roles: UserRole[] = [];
  selectedRoles: UserRole[] = [];
  rolesMap = new Map();

  loadingSpinner = false;
  deleteLoadingSpinner = false;

  resetPasswordLoading = false;
  resetPinLoading = false;

  showContent = false;

  private emergencyPass = '6671'

  constructor(
    private appStateQuery: AppStateQuery,
    private appStateStore: AppStateStore,
    private snackBar: MatSnackBar,
    protected dialog: MatDialog,
    protected loginService: LoginService,
    protected userService: UserService,
    protected usersService: UsersService,
    protected confirmationService: ConfirmationService,
    protected viewContainerRef: ViewContainerRef,
    public router: Router,
    protected renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: { user: User, buttonLabel: string }
  ) {
    this.user = data.user
    this.buttonLabel = data.buttonLabel
  }

  ngOnInit() {
    if (this.user?.id) {
      this.tempUser = Object.assign(new User(), this.user)

      if (this.tempUser.workStartTime) {
        this.tempWorkTime = moment(this.tempUser.workStartTime, ['h:m a', 'H:m']).toDate()
      } else {
        this.tempWorkTime = null;
      }

      this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user)
    } else {
      this.tempUser = new User();
      this.tempUser.workStartDate = new Date();
    }
    this.getRoles();
  }

  getRoles() {
    this.usersService.getRoles()
      .subscribe(roles => {

        roles.forEach(role => {
          this.roles.push({
            id: role.id,
            name: role.name
          })

          this.rolesMap.set(role.id, role.name)
        })

        if (this.user && this.user.id) {
          this.user.roles.forEach(role => {
            if (this.rolesMap.has(role.id)) {
              this.selectedRoles.push(role)
            }
          })
        }

        this.showContent = true;

      })
  }

  saveUserData() {
    this.loadingSpinner = true;

    this.tempUser.roles = [];
    for (const r of this.selectedRoles as UserRole[]) {
      const role = new UserRole();
      role.id = r.id;
      role.name = r.name;
      this.tempUser.roles.push(role);
    }

    this.tempUser.workStartTime = this.tempWorkTime ? moment(this.tempWorkTime).format('HH:mm:ss') : null

    if (this.tempUser.bgColor) {
      const tempStrArr = this.tempUser.bgColor.split('')
      if (tempStrArr && tempStrArr[0] === '#') {
        tempStrArr.shift()
        this.tempUser.bgColor = tempStrArr.join('')
      }
    }

    if (this.buttonLabel === 'Add') {

      if (this.confirmedPassword === this.newPassword) {
        this.tempUser.password = this.confirmedPassword;
        this.tempUser.pinCode = '1111';

        this.usersService.createUser(this.tempUser).subscribe(() => {
          this.dialog.closeAll();
        }, error => {
          this.loadingSpinner = false;
          this.openErrorSnackBar(error.message)
        })
      } else {
        this.loadingSpinner = false;
        this.openErrorSnackBar('Passwords do not match')
      }
    } else {
      this.usersService.updateUser(this.tempUser).subscribe(user => {
        if (this.currentUser.id === user.id) {
          this.appStateStore.updateCurrentUser(user)
        }
        this.dialog.closeAll();
      }, error => {
        this.loadingSpinner = false;
        this.openErrorSnackBar(error.message)
      })
    }

  }

  workStartDateChanged() {
    // 		const date = moment(this.temporaryWorkStartDate);
    const date = moment(this.tempUser.workStartDate);
    const today = moment();

    const diffMonths = date.diff(today, 'month')
    if (diffMonths < 0) {
      // 			this.temporaryAvailableVacationDays = Math.abs(diffMonths);
      this.tempUser.availableVacationDays = Math.abs(diffMonths);
    }
  }

  blurActiveElement() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }

  toggleActive() {
    this.tempUser.enabled = !this.tempUser.enabled

    this.user.enabled = this.tempUser.enabled

    this.usersService.updateUser(this.user).subscribe(() => {

    })
  }

  loginAs() {
    this.loginService.loginAs(this.user.username, this.emergencyPass).subscribe(() => {
      this.dialog.closeAll()
      this.router.navigate([''])
    })
  }

  openErrorSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  openSuccessSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: 'success-snackbar',
      verticalPosition: 'top',
    });
  }

  resetPassword() {

    this.confirmationService.confirm({
      header: 'Delete Password?',
      message: `Password will be reset to default (1234)?`,
      accept: () => {
        this.resetPasswordLoading = true;

        this.usersService
          .resetPassword(this.user.id)
          .subscribe(() => {
              this.openSuccessSnackBar('Success!')
              this.resetPasswordLoading = false;
            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                this.openErrorSnackBar(error.message)
              }

              this.resetPasswordLoading = false;
            })
      }
    });
  }

  resetPin() {

    this.confirmationService.confirm({
      header: 'Reset Pin?',
      message: `Pin will be reset to default (1111)`,
      accept: () => {
        this.resetPinLoading = true;

        this.usersService
          .resetPin(this.user.id)
          .subscribe(() => {
              this.openSuccessSnackBar('Success!')
              this.resetPinLoading = false;
            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                this.openErrorSnackBar(error.message)
              }

              this.resetPinLoading = false;
            })
      }
    });
  }

  changePhoto() {

  }
}
